export default __webpack_public_path__ + "37a9ce67d718fa06feadc1da936cc00c.png";